import { handleAuthError, isAuthError } from './utils/authUtils';

import { onError } from '@apollo/client/link/error';

/**
 * Creates an Apollo error link that handles GraphQL errors, including auth errors
 * This is necessary because GraphQL typically returns 200 OK status codes even for errors,
 * including authorization errors.
 *
 * @returns Apollo error link middleware
 */
export const createApolloErrorLink = () => {
  return onError(({ graphQLErrors, networkError }) => {
    // Handle GraphQL errors
    if (graphQLErrors) {
      for (const err of graphQLErrors) {
        if (isAuthError(err)) {
          console.error('Authentication error in GraphQL response:', err);
          handleAuthError();
          return;
        }

        // Log other GraphQL errors
        console.error(`[GraphQL error]: Message: ${err.message}, Location: ${err.locations}, Path: ${err.path}`, err.extensions);
      }
    }

    // Handle network errors
    if (networkError) {
      console.error(`[Network error]: ${networkError}`);
    }
  });
};
